import React, { useState, useEffect, useRef } from "react";
import "./AddWheel.css";
import CarDetailForm from "../CarDetailForm";
import { CAR_REG_NUMBER, SELL_MY_CAR_STEPS, ADD_VEHICLE } from "../../constant";
import { GET, POST, PATCH } from "../../constant/apiMethods";
import { connect } from "react-redux";
import { useContext } from "react";
import Labels from "../../services/apiLabels";
import config from "../../config";
import FeedbackContext from "../../context/cmscontext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spinner } from "react-bootstrap";
import { FiSearch } from "react-icons/fi";
import {
  authHeaders,
  isFilled,
  isNonNegativeNumber,
  isPositiveNumber,
  pickOptionId,
  readApiResponse,
} from "../../utils/formValidation";

export const API_ENDPOINT = (label) => {
  return `${config.baseUrl}${label}`;
};

function normalizeSelectValue(value) {
  if (value == null || value === "") return "";
  if (typeof value === "object") return String(pickOptionId(value) || "");
  return String(value);
}

function isPresentValue(value) {
  if (value == null) return false;
  const str = String(value).trim();
  if (!str) return false;
  const lowered = str.toLowerCase();
  return lowered !== "null" && lowered !== "none" && lowered !== "undefined";
}

function firstPresentValue(...values) {
  for (const value of values) {
    // Objects: only accept when they resolve to a real option id/label.
    if (value && typeof value === "object" && !Array.isArray(value)) {
      const id = pickOptionId(value);
      if (isPresentValue(id)) return value;
      const label = value.name || value.label || value.display || value.brand_name;
      if (isPresentValue(label)) return value;
      continue;
    }
    if (isPresentValue(value)) return value;
  }
  return "";
}

/** Map API body type (id or label) onto the form <select> values "1"–"4". */
function normalizeBodyType(value) {
  if (!isPresentValue(value) && !(value && typeof value === "object")) {
    return "";
  }
  if (typeof value === "object") {
    return normalizeBodyType(
      pickOptionId(value) || value.name || value.label || value.display
    );
  }
  const str = String(value).trim();
  if (/^[1-4]$/.test(str)) return str;
  const byLabel = {
    hatchback: "1",
    mpv: "2",
    suv: "3",
    saloon: "4",
    sedan: "4",
  };
  return byLabel[str.toLowerCase()] || "";
}

/** Category: API uses 1/2=New, 3=Used (and sometimes labels). */
function normalizeCategory(value) {
  const raw = normalizeSelectValue(value);
  if (!raw) return "";
  const lowered = raw.toLowerCase();
  if (lowered === "new") return "2";
  if (lowered === "used") return "3";
  // Legacy "1" is New in older records.
  if (raw === "1") return "2";
  if (raw === "2" || raw === "3") return raw;
  return raw;
}

/** API reads `car_body_type`; create/update historically post `bodytype`. */
function pickBodyTypeFromVehicle(data = {}) {
  return normalizeBodyType(
    firstPresentValue(
      data.car_body_type,
      data.body_type,
      data.bodytype,
      data.BodyType,
      data.carBodyType
    )
  );
}

function resolveEditId(isEdit) {
  if (isEdit == null || isEdit === false || isEdit === "") return null;
  if (typeof isEdit === "object") {
    return isEdit.id ?? isEdit.pk ?? isEdit.product_id ?? null;
  }
  return isEdit;
}

const AddWheel = ({
  user_id,
  getAllCars,
  setSelectedTabIdx,
  isEdit,
  setisEdit,
  car_reg_num,
  sellMyCar,
  car_reg_loading,
  reducer,
  setbrand,
  setmodel,
  setfuelType,
  setyear,
  setvariant,
  sellMyCar_new,
  prefill,
  onPrefillConsumed,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    postcode: "",
    price: "",
    vat: "",
    registration_number: "",
    millage: "",
    description: "",
  });
  const [carStepsData, setcarStepsData] = useState({});
  const [category, setCategory] = useState("");
  const [bodytype, setBodytype] = useState("");
  const [transmission, setTransmission] = useState("");
  const [regunm, setregunm] = useState("");
  const [show, setshow] = useState(false);
  const [saving, setSaving] = useState(false);
  const [touched, setTouched] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);
  // `car_reg_` survives in the store between visits, so only apply a lookup
  // result this instance actually asked for.
  const lookupRequested = useRef(false);
  const prefillRef = useRef(null);

  const { feedback } = useContext(FeedbackContext);
  const home_page = feedback.home_page;

  const lookupRegistration = (reg) => {
    lookupRequested.current = true;
    setshow(true);
    car_reg_num({ Reg_Num: reg });
  };

  const car_value = (e) => {
    e.preventDefault();
    if (!isFilled(regunm) || show) return;
    lookupRegistration(regunm);
  };

  const [carData, setcarData] = useState({
    brands: "",
    model_name: "",
    fuel_type: "",
    year: "",
  });

  const markTouched = (key) => {
    setTouched((prev) => (prev[key] ? prev : { ...prev, [key]: true }));
  };

  const editId = resolveEditId(isEdit);
  const isEditing = Boolean(editId);

  const fieldErrors = (() => {
    const errors = {};
    if (!isFilled(formData.name)) errors.name = "Required";
    if (!isFilled(category)) errors.category = "Required";
    if (!isFilled(formData.postcode)) errors.postcode = "Required";
    if (!isPositiveNumber(formData.price)) errors.price = "Enter a price greater than 0";
    if (!isNonNegativeNumber(formData.vat)) errors.vat = "Enter a valid VAT amount";
    if (!isFilled(formData.registration_number)) {
      errors.registration_number = "Required";
    }
    if (!isFilled(carData.brands)) errors.brand = "Required";
    if (!isFilled(carData.model_name)) errors.model = "Required";
    if (!isFilled(carData.fuel_type)) errors.fuel_type = "Required";
    if (!isFilled(carData.year)) errors.year = "Required";
    if (!isFilled(bodytype)) errors.bodytype = "Required";
    if (!isFilled(transmission)) errors.transmission = "Required";
    if (!isNonNegativeNumber(formData.millage)) errors.millage = "Enter mileage";
    if (!isFilled(formData.description)) errors.description = "Required";
    return errors;
  })();
  const isFormValid = Object.keys(fieldErrors).length === 0;
  const showError = (key) =>
    Boolean((submitAttempted || touched[key]) && fieldErrors[key]);

  const applyVehiclePayload = (raw = {}, options = {}) => {
    const { hydrateCascade = true } = options;
    const data = raw?.data && typeof raw.data === "object" && !Array.isArray(raw.data)
      ? raw.data
      : raw;
    if (!data || typeof data !== "object") return;

    const brand = firstPresentValue(data.brands, data.brand_name) || null;

    setFormData({
      name: data.name || "",
      postcode: data.postcode || "",
      price: data.price ?? "",
      vat: data.vat ?? "",
      registration_number: data.registration_number || "",
      millage: data.millage ?? data.mileage ?? "",
      description: data.description || "",
    });
    setCategory((prev) => normalizeCategory(data.category) || prev || "");
    setBodytype((prev) => pickBodyTypeFromVehicle(data) || prev || "");
    setTransmission((prev) => normalizeSelectValue(data.transmission) || prev || "");
    setcarData({
      brands: pickOptionId(brand),
      model_name: pickOptionId(data.model_name),
      fuel_type: pickOptionId(data.fuel_type),
      year: pickOptionId(data.year),
    });

    // Only detail payloads should drive the make/model cascade. List rows often
    // have string brand/model names which race and clear the selects.
    if (hydrateCascade) {
      setcarStepsData({
        ...data,
        brands: brand,
        brand_name: data.brand_name || brand,
        model_name: data.model_name,
        fuel_type: data.fuel_type,
        year: data.year,
      });
    }
  };

  useEffect(() => {
    if (editId) {
      // Seed scalars from the list row only (no make/model cascade).
      if (isEdit && typeof isEdit === "object") {
        applyVehiclePayload(isEdit, { hydrateCascade: false });
      }
      getSingleData({
        label: `${Labels.delvechiel}${editId}/`,
      });
      return undefined;
    }

    // Fresh "Add vehicle" visit — clear local + Redux make/model cascade.
    resetFormData(false);
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editId]);

  const [preFillData, setPreFillData] = useState('');
  const [seededReg, setSeededReg] = useState("");

  // Listing an evaluated vehicle: seed the known fields and resolve
  // brand/model/fuel/year through the registration lookup.
  useEffect(() => {
    if (!prefill) return;
    prefillRef.current = prefill;
    const reg = String(prefill.registration_number || "").toUpperCase();
    setregunm(reg);
    setFormData((prev) => ({
      ...prev,
      registration_number: reg,
      name: prefill.name || prev.name,
      millage: prefill.millage ?? prev.millage,
      postcode: prefill.postcode || prev.postcode,
    }));
    setSeededReg(reg);
    if (reg) lookupRegistration(reg);
    if (typeof onPrefillConsumed === "function") onPrefillConsumed();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefill]);

  useEffect(() => {
    if (!lookupRequested.current) return;
    const seeded = prefillRef.current || {};
    if (sellMyCar_new?.brands) {
      lookupRequested.current = false;
      setshow(false);
      setFormData((prev) => ({
        name: sellMyCar_new?.variant?.display || seeded.name || prev.name || "",
        postcode: sellMyCar_new.postcode || seeded.postcode || prev.postcode || "",
        price: sellMyCar_new.price || prev.price || "",
        vat: sellMyCar_new.vat || prev.vat || "",
        registration_number: (
          regunm ||
          seeded.registration_number ||
          ""
        ).toUpperCase(),
        millage: sellMyCar_new.millage || seeded.millage || prev.millage || "",
        description: sellMyCar_new.description || prev.description || "",
      }));
      setcarStepsData(sellMyCar_new);
      return;
    }
    if (sellMyCar_new?.status === "error") {
      lookupRequested.current = false;
      setshow(false);
      toast.error("Registration not found. Enter the vehicle details manually.", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  }, [sellMyCar_new, regunm]);

  useEffect(() => {
    if (!show) return undefined;
    const timeout = window.setTimeout(() => setshow(false), 20000);
    return () => window.clearTimeout(timeout);
  }, [show]);

  const notify = (masg) =>
    toast.error(`${masg}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const readURL = (file) => {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onload = (e) => res(e.target.result);
      reader.onerror = (e) => rej(e);
      reader.readAsDataURL(file);
    });
  };

  const handleImageChange = async (e) => {
    let file = e.target.files[0];
    const url = await readURL(file);
  };

  const updateData = (e) => {
    const { name, value } = e.target;
    markTouched(name);
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitAttempted(true);
    if (!isFormValid || saving) return;

    const data = new FormData();
    data.append("name", formData.name.trim());
    data.append("category", category);
    data.append("postcode", formData.postcode.trim());
    data.append("registration_number", formData.registration_number.trim());
    data.append("bodytype", bodytype);
    data.append("car_body_type", bodytype);
    data.append("transmission", transmission);
    data.append("millage", formData.millage);
    data.append("vat", formData.vat);
    data.append("price", formData.price);
    data.append("description", formData.description.trim());
    data.append("brands", carData.brands);
    data.append("model_name", carData.model_name);
    data.append("fuel_type", carData.fuel_type);
    data.append("year", carData.year);
    data.append("created_by", user_id);

    const payload = isEditing
      ? {
          label: `${Labels.delvechiel}${editId}/`,
          method: PATCH,
          data,
        }
      : {
          label: `${Labels.addvechiel}`,
          method: POST,
          data,
        };

    await saveVehicle(payload);
  };

  async function saveVehicle(payload) {
    const { label, data, method } = payload;
    setSaving(true);
    try {
      const response = await fetch(API_ENDPOINT(label), {
        method,
        headers: authHeaders(),
        body: data,
      });
      const parsed = await readApiResponse(
        response,
        "Unable to save vehicle. Please check required fields and try again."
      );
      if (!parsed.ok) {
        notify(parsed.description);
        return;
      }
      toast.success(isEditing ? "Vehicle updated." : "Vehicle saved.", {
        position: "top-right",
        autoClose: 4000,
      });
      getAllCars();
      setisEdit(null);
      setSelectedTabIdx(0);
      resetFormData(false);
    } catch (err) {
      notify("Unable to save vehicle. Please try again.");
    } finally {
      setSaving(false);
    }
  }

  function getSingleData(payload) {
    const { label } = payload;
    fetch(API_ENDPOINT(label), {
      method: GET,
      headers: authHeaders({ Accept: "application/json" }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Unable to load vehicle");
        return response.json();
      })
      .then((json) => {
        applyVehiclePayload(json?.data || json || {}, { hydrateCascade: true });
      })
      .catch(() => {
        notify("Unable to load this vehicle.");
      });
  }

  const resetFormData = (reload = false) => {
    const emptyStep = {
      fetching: false,
      data: [],
      isSelected: false,
      current: {},
    };
    setFormData({
      name: "",
      postcode: "",
      price: "",
      vat: "",
      registration_number: "",
      millage: "",
      description: "",
    });
    setCategory("");
    setBodytype("");
    setTransmission("");
    setcarData({
      brands: "",
      model_name: "",
      fuel_type: "",
      year: "",
    });
    setcarStepsData({});
    setTouched({});
    setSubmitAttempted(false);
    setregunm("");
    setSeededReg("");
    setshow(false);
    setPreFillData("");
    prefillRef.current = null;
    lookupRequested.current = false;
    // Clear shared sellMyCar step1 selections so the next add starts blank.
    if (typeof setbrand === "function") setbrand(emptyStep);
    if (typeof setmodel === "function") setmodel(emptyStep);
    if (typeof setfuelType === "function") setfuelType(emptyStep);
    if (typeof setyear === "function") setyear(emptyStep);
    if (typeof setvariant === "function") setvariant(emptyStep);
    if (reload) window.location.reload();
  };
  
  return (
    <div className="dd-vehicle-form">
      <header className="dd-vehicle-form__intro">
        <p className="dd-vehicle-form__eyebrow">
          {isEditing ? "Update listing" : "New listing"}
        </p>
        <h2>{isEditing ? "Edit vehicle" : "Add vehicle"}</h2>
        <p>
          {seededReg && !isEditing
            ? `Details for ${seededReg} came from your evaluation. Add price and listing details, save, then use List to set auction or buy now.`
            : "Look up a registration to prefill details, then complete the listing fields below."}
        </p>
      </header>

      <section className="dd-vehicle-card dd-vehicle-card--lookup">
        <div className="dd-vehicle-card__head">
          <h3>Registration lookup</h3>
          <p>Enter a registration to prefill brand, model, and related fields.</p>
        </div>
        <form
          className="dd-reg-search"
          onSubmit={car_value}
          autoComplete="off"
        >
          <label className="dd-reg-search__label" htmlFor="dd-vehicle-reg">
            Registration number
          </label>
          <div className="dd-reg-search__control">
            <input
              id="dd-vehicle-reg"
              required
              type="text"
              value={regunm || ""}
              maxLength={20}
              onChange={(e) => {
                setregunm(e.target.value.toUpperCase());
              }}
              placeholder={
                home_page?.car_reg_placeholder || "Enter registration"
              }
              aria-label="Registration or plate number"
            />
            <button
              className="dd-reg-search__btn"
              name="CTAButton"
              type="submit"
              disabled={show}
              aria-label="Look up registration"
            >
              {show ? (
                <Spinner animation="border" variant="light" size="sm" />
              ) : (
                <FiSearch size={16} aria-hidden />
              )}
            </button>
          </div>
        </form>
      </section>

      <form className="dd-vehicle-card" onSubmit={handleSubmit} noValidate>
        <div className="dd-vehicle-card__head">
          <h3>Vehicle details</h3>
          <p>Basic listing information shown to buyers.</p>
        </div>

        <div className="dd-form-grid">
          <div className={`dd-field${showError("name") ? " is-invalid" : ""}`}>
            <label htmlFor="name-f">Name *</label>
            <input
              type="text"
              name="name"
              id="name-f"
              value={formData.name}
              placeholder="Enter vehicle name"
              onChange={updateData}
              onBlur={() => markTouched("name")}
            />
            {showError("name") ? (
              <p className="dd-password__error">{fieldErrors.name}</p>
            ) : null}
          </div>

          <div className={`dd-field${showError("category") ? " is-invalid" : ""}`}>
            <label htmlFor="category">Category *</label>
            <select
              id="category"
              name="category"
              value={category == null ? "" : String(category)}
              onChange={(e) => {
                markTouched("category");
                setCategory(e.target.value);
              }}
              onBlur={() => markTouched("category")}
            >
              <option value="">Select category</option>
              <option value="2">New</option>
              <option value="3">Used</option>
            </select>
            {showError("category") ? (
              <p className="dd-password__error">{fieldErrors.category}</p>
            ) : null}
          </div>

          <div className={`dd-field${showError("postcode") ? " is-invalid" : ""}`}>
            <label htmlFor="postcode">Post code *</label>
            <input
              type="text"
              name="postcode"
              id="postcode"
              value={formData.postcode}
              placeholder="Enter post code"
              onChange={updateData}
              onBlur={() => markTouched("postcode")}
            />
            {showError("postcode") ? (
              <p className="dd-password__error">{fieldErrors.postcode}</p>
            ) : null}
          </div>

          <div className={`dd-field${showError("price") ? " is-invalid" : ""}`}>
            <label htmlFor="price">Price *</label>
            <input
              type="number"
              name="price"
              id="price"
              min="0"
              step="0.01"
              value={formData.price}
              placeholder="Enter price"
              onChange={updateData}
              onBlur={() => markTouched("price")}
            />
            {showError("price") ? (
              <p className="dd-password__error">{fieldErrors.price}</p>
            ) : null}
          </div>

          <div className={`dd-field${showError("vat") ? " is-invalid" : ""}`}>
            <label htmlFor="vat">VAT *</label>
            <input
              type="number"
              name="vat"
              id="vat"
              min="0"
              step="0.01"
              value={formData.vat}
              placeholder="Enter VAT"
              onChange={updateData}
              onBlur={() => markTouched("vat")}
            />
            {showError("vat") ? (
              <p className="dd-password__error">{fieldErrors.vat}</p>
            ) : null}
          </div>

          <div
            className={`dd-field${
              showError("registration_number") ? " is-invalid" : ""
            }`}
          >
            <label htmlFor="registration_number">Registration number *</label>
            <input
              type="text"
              name="registration_number"
              id="registration_number"
              value={formData.registration_number}
              disabled={Boolean(sellMyCar_new?.api_data)}
              placeholder="Enter registration number"
              onChange={updateData}
              onBlur={() => markTouched("registration_number")}
            />
            {showError("registration_number") ? (
              <p className="dd-password__error">
                {fieldErrors.registration_number}
              </p>
            ) : null}
          </div>
        </div>

        <div className="dd-vehicle-card__divider" />

        <div className="dd-vehicle-card__head dd-vehicle-card__head--tight">
          <h3>Make & model</h3>
          <p>Brand, model, fuel type, and year.</p>
        </div>

        <div className="dd-form-grid dd-vehicle-form__car-detail">
          <CarDetailForm
            isEdit={editId}
            carStepsData={carStepsData}
            carData={carData}
            sellMyCar_new={sellMyCar_new}
            setcarData={setcarData}
            preFillData={preFillData}
            reducer="sellMyCar"
            reduxType={"SELL_MY_CAR_STEPS"}
            uiVariant="dashboard"
            fieldErrors={{
              brand: showError("brand") ? fieldErrors.brand : "",
              model: showError("model") ? fieldErrors.model : "",
              fuel_type: showError("fuel_type") ? fieldErrors.fuel_type : "",
              year: showError("year") ? fieldErrors.year : "",
            }}
          />
        </div>

        <div className="dd-vehicle-card__divider" />

        <div className="dd-vehicle-card__head dd-vehicle-card__head--tight">
          <h3>Specification</h3>
          <p>Body type, transmission, mileage, and notes.</p>
        </div>

        <div className="dd-form-grid">
          <div className={`dd-field${showError("bodytype") ? " is-invalid" : ""}`}>
            <label htmlFor="bodytype">Body type *</label>
            <select
              id="bodytype"
              name="bodytype"
              value={bodytype == null ? "" : String(bodytype)}
              onChange={(e) => {
                markTouched("bodytype");
                setBodytype(e.target.value);
              }}
              onBlur={() => markTouched("bodytype")}
            >
              <option value="">Select body type</option>
              <option value="1">Hatchback</option>
              <option value="2">MPV</option>
              <option value="3">SUV</option>
              <option value="4">Saloon</option>
            </select>
            {showError("bodytype") ? (
              <p className="dd-password__error">{fieldErrors.bodytype}</p>
            ) : null}
          </div>

          <div
            className={`dd-field${showError("transmission") ? " is-invalid" : ""}`}
          >
            <label htmlFor="transmission">Transmission *</label>
            <select
              id="transmission"
              name="transmission"
              value={transmission}
              onChange={(e) => {
                markTouched("transmission");
                setTransmission(e.target.value);
              }}
              onBlur={() => markTouched("transmission")}
            >
              <option value="">Select transmission</option>
              <option value="1">Auto</option>
              <option value="2">Manual</option>
              <option value="3">Both</option>
            </select>
            {showError("transmission") ? (
              <p className="dd-password__error">{fieldErrors.transmission}</p>
            ) : null}
          </div>

          <div className={`dd-field${showError("millage") ? " is-invalid" : ""}`}>
            <label htmlFor="millage">Mileage *</label>
            <input
              type="number"
              name="millage"
              id="millage"
              min="0"
              value={formData.millage}
              placeholder="Enter mileage"
              onChange={updateData}
              onBlur={() => markTouched("millage")}
            />
            {showError("millage") ? (
              <p className="dd-password__error">{fieldErrors.millage}</p>
            ) : null}
          </div>

          <div
            className={`dd-field dd-field--full${
              showError("description") ? " is-invalid" : ""
            }`}
          >
            <label htmlFor="description">Description *</label>
            <textarea
              id="description"
              name="description"
              rows={5}
              placeholder="Leave a comment here"
              value={formData.description}
              onChange={updateData}
              onBlur={() => markTouched("description")}
            />
            {showError("description") ? (
              <p className="dd-password__error">{fieldErrors.description}</p>
            ) : null}
          </div>
        </div>

        <div className="dd-vehicle-form__footer">
          <button
            type="button"
            className="dd-btn dd-btn--ghost"
            onClick={() => {
              resetFormData(false);
              setisEdit(null);
              setSelectedTabIdx(0);
            }}
          >
            Cancel
          </button>
          <button
            className="dd-btn dd-btn--primary"
            type="submit"
            disabled={!isFormValid || saving}
          >
            {saving
              ? isEditing
                ? "Updating…"
                : "Saving…"
              : isEditing
              ? "Update vehicle"
              : "Save vehicle"}
          </button>
        </div>
      </form>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user_id: state.auth.id,
  myVehiclesList: state?.myVehicles?.data,
  sellMyCar_new: state.sellMyCar.car_reg_,
  car_reg_loading: state.sellMyCar.car_reg_loading,

  fetchingBrands: state.sellMyCar.fetchingBrands,
  brands: state.sellMyCar.brands,
  //
  showInterest: state.showInterest,
  sellMyCar: state.sellMyCar,
});

const mapDispatchToProps = (dispatch) => ({
  car_reg_num: (data) =>
    dispatch({
      type: CAR_REG_NUMBER,
      payload: {
        type: CAR_REG_NUMBER,
        method: POST,
        label: Labels.car_reg_chk,
        hideOverlayLoader: true,
        data,
      },
    }),

  setbrand: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "brand",
        data,
      },
    }),
  setmodel: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "model",
        data,
      },
    }),
  setfuelType: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "fuel_type",
        data,
      },
    }),
  setyear: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "year",
        data,
      },
    }),
  setvariant: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "variant",
        data,
      },
    }),

  addvechiel: (data) =>
    dispatch({
      type: ADD_VEHICLE,
      payload: {
        type: ADD_VEHICLE,
        data,
        label: `${Labels.addvechiel}`,
        method: POST,

        hideOverlayLoader: true,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddWheel);